export default __webpack_public_path__ + "static/media/bazzle1.dbd07936.png";